import { makeStyles, tokens } from "@fluentui/react-components";
import { Attach16Regular } from "@fluentui/react-icons";
import * as React from "react";
import type { UserMessage } from "@/types";

type Props = {
  message: UserMessage;
};

export default function UserMessageCard(props: Props) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {props.message.content.text}
        {props.message.content.includesAttachments && (
          <div className={styles.attachment}>
            <Attach16Regular /> Attachment
          </div>
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "flex-end",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    backgroundColor: tokens.colorPaletteLavenderBackground2,
    borderRadius: "8px",
    marginLeft: "48px",
    padding: "16px",
    fontSize: "12px",
  },

  attachment: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    color: tokens.colorPaletteLavenderForeground2,
  },
});
